
import React, { useState } from 'react';
import { convertWordToPdf } from '../utils/wordToPdf';

const WordToPDF = () => {
    const [file, setFile] = useState(null);
    const [converting, setConverting] = useState(false);
    const [error, setError] = useState('');
    const fileInputRef = React.useRef(null);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
        setError('');
    };

    const handleConvert = async (e) => {
        // Blur the button to remove focus state
        if (e && e.target) {
            e.target.blur();
        }

        if (!file) {
            setError('Please select a Word file first.');
            return;
        }

        if (file.type !== "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
            setError("Invalid file type. Please upload a .docx file.");
            return;
        }

        setConverting(true);
        setError('');

        try {
            const pdfBlob = await convertWordToPdf(file);
            const url = URL.createObjectURL(pdfBlob);

            // Auto download
            const a = document.createElement('a');
            a.href = url;
            a.download = `${file.name.replace('.docx', '')}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            // Clear file selection after successful conversion
            setFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        } catch (err) {
            console.error(err);
            setError('Error converting file. Please try again.');
        } finally {
            setConverting(false);
        }
    };

    return (
        <div className="converter-section">
            <h2>Word to PDF</h2>

            <div className="input-group">
                <input
                    type="file"
                    accept=".docx"
                    onChange={handleFileChange}
                    ref={fileInputRef}
                />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button
                onClick={handleConvert}
                disabled={converting || !file}
                className="convert-btn"
            >
                {converting ? 'Converting...' : 'Convert to PDF'}
            </button>

            {converting && <div className="loading-indicator">Processing...</div>}
        </div>
    );
};

export default WordToPDF;
